/*
 *  I16DIMADOUCISSEURPRIMI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 15:48:07 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I16DIMADOUCISSEURPRIM_SECTION_0_TITLE: 'Dimensionnez le volume de résine en fonction de vos appoints réseau',
  I16DIMADOUCISSEURPRIM_in_thEauVille: 'Th° eau de ville',
  I16DIMADOUCISSEURPRIM_in_thSouhaite: 'Th° souhaité',
  I16DIMADOUCISSEURPRIM_I12VOLINSTCHAUF: 'Calculer le volume ou saissisez manuellement',
  I16DIMADOUCISSEURPRIM_in_volInst: "Volume de l'installation",
  I16DIMADOUCISSEURPRIM_cpcTraitementLitreResine_uuid: 'Efficacité de la résine',
  I16DIMADOUCISSEURPRIM_in_resineSouhaite: 'Nombre de litre de résine souhaité',
  I16DIMADOUCISSEURPRIM_SECTION_1_TITLE: 'Caractéristique de la résine et du bac',
  I16DIMADOUCISSEURPRIM_res_cpcTraitementResine: 'Capacité de traitement de la résine',
  I16DIMADOUCISSEURPRIM_res_traitementPrevoir: 'Traitement à prévoir',
  I16DIMADOUCISSEURPRIM_res_volAvantRegen: 'Volume avant régénération',
  I16DIMADOUCISSEURPRIM_res_consoSalt: 'Consommation de sel par régénération',
  I16DIMADOUCISSEURPRIM_res_consoEauRenvoie: "Consommation d'eau de renvoie",
  I16DIMADOUCISSEURPRIM_res_tauxSodiumEau: "Taux de sodium dans l'eau",
  I16DIMADOUCISSEURPRIM_SECTION_2_TITLE: 'Caractéristique du débit à prévoir',
  I16DIMADOUCISSEURPRIM_in_debitHPointe: 'Débit horaire souhaité',
  I16DIMADOUCISSEURPRIM_res_diamAdouc: 'Diamètre adoucisseur recommandé'
}
